import React from "react";
import { Modal } from "@geotab/zenith";
import LoginTranslations from "../../../helpers/translations";
import type { TTranslate } from "../../../helpers/renderUntilAnswered";

interface IPasswordUpdatedModalProps {
    translate: TTranslate;
    onContinue: () => void;
}

/** A copy of the MyGeotab password update confirmation. Going on with login is the only action, so it has no close button. */
const PasswordUpdatedModal: React.FC<IPasswordUpdatedModalProps> = ({ translate, onContinue }: IPasswordUpdatedModalProps) => (
    <Modal isOpen={true} title={translate(LoginTranslations.PasswordUpdated)} type="success" focus="primary">
        <div>{translate(LoginTranslations.PasswordUpdatedMessage)}</div>
        <Modal.PrimaryButton className="login-primary-button" onClick={onContinue}>{translate(LoginTranslations.GoToApplication)}</Modal.PrimaryButton>
    </Modal>
);

export default PasswordUpdatedModal;
